import React from 'react';
import { PeptideSelect } from './PeptideSelect';
import { VialInputs } from './VialInputs';
import { DosageInputs } from './DosageInputs';
import { SyringeInput } from './SyringeInput';
import { CalculatorButtons } from './CalculatorButtons';
import { CalculatorInputs } from '../../../types/calculator';
import type { Unit } from '../../../constants/units';

interface CalculatorFormProps {
  inputs: CalculatorInputs;
  errors: Partial<Record<keyof CalculatorInputs, string>>;
  onInputChange: (updates: Partial<CalculatorInputs>) => void;
  onCalculate: () => void;
  onReset: () => void;
}

export const CalculatorForm: React.FC<CalculatorFormProps> = ({
  inputs,
  errors,
  onInputChange,
  onCalculate,
  onReset,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        <div className="lg:col-span-2">
          <img
            src="/images/peptides.jpg" 
            alt="Peptides"
            className="w-full h-64 object-cover rounded-lg shadow-md mb-4"
          />
          <p className="text-sm text-gray-600 text-center">
            Calculate precise dosage metrics for your peptide vials
          </p>
        </div>
        
        <div className="lg:col-span-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="md:col-span-2">
              <PeptideSelect
                value={inputs.peptideName}
                onChange={(value) => onInputChange({ peptideName: value })}
                error={errors.peptideName}
              />
            </div>
            
            <VialInputs
              amount={inputs.vialAmount}
              units={inputs.vialUnits}
              onAmountChange={(value) => onInputChange({ vialAmount: value })}
              onUnitsChange={(value) => onInputChange({ vialUnits: value as Unit })}
              error={errors.vialAmount}
            />
            
            <DosageInputs
              dosage={inputs.dosage}
              dosageUnits={inputs.dosageUnits}
              onDosageChange={(value) => onInputChange({ dosage: value })}
              onUnitsChange={(value) => onInputChange({ dosageUnits: value as Unit })}
              error={errors.dosage}
            />
            
            <SyringeInput
              value={inputs.targetSyringeUnits}
              onChange={(value) => onInputChange({ targetSyringeUnits: value })}
              error={errors.targetSyringeUnits}
            />
          </div>

          <CalculatorButtons onCalculate={onCalculate} onReset={onReset} />
        </div>
      </div>
    </div>
  );
};
